import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import AppShell from "@/components/AppShell";
import Everything from "@/pages/Everything";
import Spaces from "@/pages/Spaces";
import SpaceDetail from "@/pages/SpaceDetail";
import Tasks from "@/pages/Tasks";
import Planner from "@/pages/Planner";
import Focus from "@/pages/Focus";
import Habits from "@/pages/Habits";
import Rewards from "@/pages/Rewards";
import Dashboard from "@/pages/Dashboard";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-white/60">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Router() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><AppShell /></Protected>}>
        <Route index element={<Navigate to="/everything" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="everything" element={<Everything />} />
        <Route path="spaces" element={<Spaces />} />
        <Route path="spaces/:spaceId" element={<SpaceDetail />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="planner" element={<Planner />} />
        <Route path="focus" element={<Focus />} />
        <Route path="habits" element={<Habits />} />
        <Route path="rewards" element={<Rewards />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router />
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
